import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';

@Component({
  selector: 'sd-cart-cross-button',
  imports: [SdvorIconComponent],
  templateUrl: './cart-cross-button.component.html',
  styleUrls: ['./cart-cross-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartCrossButtonComponent {
  protected readonly iconTypes = IconTypes;
  protected readonly removeItem = output<void>();
}
